import { sessaoFetchLogout, appFetchRefresh, appFetchLoading, appFetch } from '@/service/fetch'

export async function logar (dados) {
  return appFetchLoading('consig', '/login/AuthenticateEnvelopado', 'POST', dados)
  // return appFetchLoading('base', '/auth/login', 'POST', dados)
}

export async function logarToken (dados) {
  return appFetch('consig', '/login/AuthenticateEnvelopadoToken', 'POST', dados)
  // return appFetchLoading('base', '/auth/login', 'POST', dados)
}

export async function refresh (refresh) {
  return appFetchRefresh('consig', '/refresh/PutEnvelopado', 'PUT', { refresh })
}

export async function logout (token) {
  return sessaoFetchLogout('consig', '/logout/', 'DELETE', { token })
}

export async function recuperaSenha (dados) {
  return appFetchLoading('consig', '/login/EsqueciSenha', 'PUT', dados)
}



// WEBPACK FOOTER //
// ./src/api/auth.js